<template>
  <div class="container">
    <progressive-background
      class="tertiary user-info"
      :src="hiresDashboardImagePath"
      :placeholder="thumbnailDashboardImagePath"
      no-ratio
    >
      <div slot="content">
        <div class="new-window-spacer" />
        <ecommerce-modal
          :show-slider="true"
          :close-button="false"
          :show-new-window="false"
        />
      </div>
    </progressive-background>
  </div>
</template>

<script>
import ecommerceModal from '@/components/modals/EcommModal'

export default {

  name: 'EcommTourNewWindow',
  components: {
    ecommerceModal
  },

  computed: {
    thumbnailDashboardImagePath () {
      return require('../assets/thumbnails/thumb_dashboard.jpg')
    },
    hiresDashboardImagePath () {
      return require('../assets/dashboard_greyscale.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';

.tertiary .progressive-background-slot:before {
  background-color: var(--tertiary-color);
}

.new-window-spacer {
  height: 380px;
}

@media only screen and (min-height: 600px) {
  .new-window-spacer {
    height: 670px;
  }
}

@media only screen and (min-height: 700px) {
  .new-window-spacer {
    height: 700px;
  }
}

@media only screen and (min-height: 768px) {
  .new-window-spacer {
    height: 768px;
  }
}

@media only screen and (max-height: 800px) {
  .new-window-spacer {
    height: 800px;
  }
}

@media only screen and (max-height: 900px) {
  .new-window-spacer {
    height: 900px;
  }
}

@media only screen and (min-height: 991px) {
  .new-window-spacer {
    height: 300px;
  }
}

@media only screen and (min-height:1024px) {
  .new-window-spacer {
    height: 1024px;
  }
}

@media only screen and (min-height:1200px) {
  .new-window-spacer {
    height: 1200px;
  }
}

</style>
